module.exports = __webpack_public_path__ + "assets/img/17_988_big.35ad6ecc.jpg";